import { render } from "./ArticleView.vue?vue&type=template&id=1c34fc6c&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=1c34fc6c&scoped=true&lang=scss"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c34fc6c"]])

export default __exports__